import ActivityLog from '../components/ActivityLog/ActivitiesLog';

export const DEFAULT_ACTIONS = ({ activityProps = {} }) => [
  {
    hasExport: true,
    sortIndex: 10,
    id: 'activity',
    name: 'Activity logs',
    icon: 'activity-log-mono',
    color: 'primary-500',
    ...activityProps,
    component: <ActivityLog />
  }
];
